module.exports = __webpack_public_path__ + "static/media/0009.48e06181.png";